import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { type SxProps, useTheme } from "@mui/material/styles";

import { formatBytes } from "utils/common";

type DisplayUploadSelectedFilesProps = {
  selectedFiles?: any;
  setSelectedFiles?: React.Dispatch<React.SetStateAction<any[]>>;
  sx?: SxProps;
};
export default function DisplayUploadSelectedFiles({
  selectedFiles,
  setSelectedFiles,
  sx
}: DisplayUploadSelectedFilesProps) {
  const theme = useTheme();
  if (!selectedFiles?.length) return null;
  return (
    <ol>
      <Stack
        spacing={2}
        sx={{
          minWidth: "300px",
          minHeight: "50px",
          maxHeight: "150px",
          ...sx
        }}
        borderTop="1px solid #E0E0E0"
        py={2}
      >
        {selectedFiles.map((item: any) => {
          return (
            <li key={item.id}>
              <Box
                sx={{
                  position: "relative",
                  backgroundColor: `${theme.palette.info.light}10`,
                  borderRadius: 1.5,
                  p: 0.5,
                  "&:hover": {
                    cursor: "move"
                  }
                }}
              >
                <Box display="flex" sx={{ alignItems: "center" }}>
                  {item.thumbnailUrl ? (
                    <img
                      style={{ height: "24px", width: "24px" }}
                      src={item.thumbnailUrl || ""}
                      alt="Preview"
                    />
                  ) : (
                    <AttachFileIcon sx={{ height: "24px", width: "24px" }} />
                  )}

                  <Box sx={{ ml: 1 }}>
                    <Typography sx={{ mb: 1 }}>{item.name}</Typography>
                    <Typography variant="body2">
                      {formatBytes(item.size)}
                    </Typography>
                  </Box>
                </Box>
                <IconButton
                  onClick={() =>
                    setSelectedFiles?.((prev: any) =>
                      prev.filter((file: any) => file.id === item.id)
                    )
                  }
                  sx={{
                    color: theme.palette.error.main,
                    position: "absolute",
                    right: "1rem",
                    top: "50%",
                    transform: "translateY(-50%)"
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            </li>
          );
        })}
      </Stack>
    </ol>
  );
}
